<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard
          ref="formWizard"
          v-if="this.isCreate() || this.isUpdate()"
          @on-complete="storeUpdateCalendar"
          title
          subtitle
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.save')"
          class="custom-padding-wz-header"
        >
          <tab-content
            :title="$t('common_words.general_information')"
            :before-change="() => validateStep('firstStep')"
          >
            <first-step
              ref="firstStep"
              @on-validated="onStepValidated"
              @fillCalendarForm="fillCalendarForm"
              @showHideLoading="showHideLoading"
            ></first-step>
          </tab-content>
          <tab-content
            :title="$t('common_words.calendar_detail')"
            :before-change="() => validateStep('secondStep')"
          >
            <second-step
              ref="secondStep"
              @on-validated="onStepValidated"
              @fillCalendarForm="fillCalendarForm"
              @showHideLoading="showHideLoading"
            ></second-step>
          </tab-content>
          <tab-content
            :title="$t('common_words.association')"
            :before-change="() => validateStep('thirdStep')"
          >
            <third-step
              ref="thirdStep"
              @on-validated="onStepValidated"
              @fillCalendarForm="fillCalendarForm"
              @showHideLoading="showHideLoading"
            ></third-step>
          </tab-content>
          <tab-content :title="$t('common_words.confirm')">
            <p class="cm-mg-p-wzd text-center text-muted">
              5.1 {{ $t('common_words.verify_inputed_information') }}
            </p>
            <br />
            <div class="row d-flex justify-content-center">
              <div class="col-9">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.name') }}:</strong>
                        </h6>
                        {{ calendarForm.name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{
                              $t('common_words.associated_companies')
                            }}:</strong
                          >
                        </h6>
                        <span
                          v-for="(
                            business, index
                          ) in calendarForm.names_business"
                          :key="index"
                        >
                          <el-tag type="info">{{ business }}</el-tag>
                        </span>
                        <el-tag
                          type="warning"
                          v-if="calendarForm.names_business.length == 0"
                          >{{
                            $t('common_words.no_associated_companies')
                          }}</el-tag
                        >
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{ $t('common_words.associated_farms') }}:</strong
                          >
                        </h6>
                        <span
                          v-for="(farm, index) in calendarForm.names_farms"
                          :key="index"
                        >
                          <el-tag type="info">{{ farm }}</el-tag>
                        </span>
                        <el-tag
                          type="warning"
                          v-if="calendarForm.names_farms.length == 0"
                          >{{ $t('common_words.no_associated_farms') }}</el-tag
                        >
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td style="padding-left: 0; padding-right: 0">
                        <h6
                          style="padding: 15px"
                          class="custom-margin-h6-table"
                        >
                          <strong
                            >{{ $t('common_words.calendar_detailof') }}:</strong
                          >
                        </h6>
                        <el-container style="border: 1px solid #eee">
                          <el-aside width="160px" style="overflow-x: hidden">
                            <el-menu :default-openeds="['1']">
                              <el-submenu index="1">
                                <template slot="title"
                                  ><em class="el-icon-date"></em
                                  >{{ $t('common_words.years') }}</template
                                >
                                <el-menu-item-group
                                  class="custom-el-menu-item-group-cal"
                                >
                                  <el-menu-item
                                    @click="changeOptionYear(y)"
                                    v-for="y in calendarForm.years"
                                    :key="y"
                                    v-bind:class="
                                      y == calendarForm.yearSel
                                        ? 'is-active'
                                        : ''
                                    "
                                    v-bind:index="y + '-' + y"
                                    style="min-width: 140px"
                                    class="custom-el-menu-item-cal"
                                  >
                                    {{ y }}
                                  </el-menu-item>
                                </el-menu-item-group>
                              </el-submenu>
                            </el-menu>
                          </el-aside>
                          <el-container>
                            <el-main>
                              <table class="table">
                                <thead class="thead-dark">
                                  <tr>
                                    <th scope="col" class="text-center">
                                      {{ $t('common_words.week') }}
                                    </th>
                                    <th scope="col" class="text-center">
                                      {{ $t('common_words.starting_week') }}
                                    </th>
                                    <th scope="col" class="text-center">
                                      {{ $t('common_words.end_week') }}
                                    </th>
                                    <th scope="col" class="text-center">
                                      {{ $t('production.ribbon') }}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(w, i) in calendarForm.weeks[
                                      calendarForm.yearSel
                                    ]"
                                    :key="i"
                                  >
                                    <td>
                                      <p class="text-center">
                                        Sem
                                        {{
                                          calendarForm.weeks[
                                            calendarForm.yearSel
                                          ][w - 1]
                                        }}
                                      </p>
                                    </td>
                                    <td>
                                      <p class="text-center">
                                        {{
                                          calendarForm.init_dates_week[
                                            calendarForm.yearSel
                                          ][w - 1]
                                            ? formatDateWeek(
                                                calendarForm.init_dates_week[
                                                  calendarForm.yearSel
                                                ][w - 1]
                                              )
                                            : 'No Aplica'
                                        }}
                                      </p>
                                    </td>
                                    <td>
                                      <p class="text-center">
                                        {{
                                          calendarForm.end_dates_week[
                                            calendarForm.yearSel
                                          ][w - 1]
                                            ? formatDateWeek(
                                                calendarForm.end_dates_week[
                                                  calendarForm.yearSel
                                                ][w - 1]
                                              )
                                            : 'No Aplica'
                                        }}
                                      </p>
                                    </td>
                                    <td>
                                      <el-tag
                                        class="text-center"
                                        v-bind:style="
                                          calendarForm.names_ribbons[
                                            calendarForm.yearSel
                                          ][w - 1]
                                            ? 'width: 100%;background-color:' +
                                              calendarForm.names_ribbons[
                                                calendarForm.yearSel
                                              ][w - 1].color_code +
                                              ';color:' +
                                              calendarForm.names_ribbons[
                                                calendarForm.yearSel
                                              ][w - 1].color_text +
                                              ''
                                            : 'width: 100%;background-color:white'
                                        "
                                      >
                                        {{
                                          calendarForm.names_ribbons[
                                            calendarForm.yearSel
                                          ][w - 1]
                                            ? calendarForm.names_ribbons[
                                                calendarForm.yearSel
                                              ][w - 1].color_name
                                            : 'No asignado'
                                        }}
                                      </el-tag>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </el-main>
                          </el-container>
                        </el-container>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </tab-content>
        </form-wizard>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import FirstStep from './steps/FirstStep.vue';
import SecondStep from './steps/SecondStep.vue';
import ThirdStep from './steps/ThirdStep.vue';
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import moment from 'moment';
import { Axios } from 'src/class/Axios.js';
import { showContinue } from 'src/util/Util.js';
import MixinMenu from 'src/util/mixinMenu';

export default {
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
  },

  data() {
    return {
      title: '',
      calendarForm: {
        names_business: [],
        names_farms: [],
        names_ribbons: {},
        weeks: {},
        yearSel: null,
        years: [],
      },
      wizardModel: {},
      renderComponent: true,
    };
  },

  mixins: [MixinPermissions, mixinMasters, MixinMenu],

  methods: {
    cleanAllSteps() {
      this.$refs.firstStep.model = {
        name: null,
        calendar_type: '1',
      };
      this.$refs.secondStep.model = {
        weeks: { [moment().format('Y')]: [] },
        init_dates_week: { [moment().format('Y')]: [] },
        end_dates_week: { [moment().format('Y')]: [] },
        ribbons: { [moment().format('Y')]: [] },
        years: [moment().format('Y')],
        yearSel: null,
        details_id: {},
      };
      this.$refs.thirdStep.model = {};
      this.calendarForm = {
        names_business: [],
        names_farms: [],
        names_ribbons: {},
        weeks: {},
        yearSel: null,
        years: [],
      };
    },

    formatDateWeek(date_week) {
      return moment(date_week).format('YYYY-MM-DD');
    },

    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },

    fillCalendarForm(ref, others) {
      this.calendarForm = Object.assign(
        {},
        this.calendarForm,
        this.$refs[ref].model
      );

      if (others)
        this.calendarForm = Object.assign({}, this.calendarForm, others);
    },

    storeUpdateCalendar() {
      this.showHideLoading(true);
      this.calendarForm.route = 'calendars';
      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.calendarForm.id = JSON.parse(
            sessionStorage.getItem('editForm')
          ).id;
          Axios.updateMaster(this.calendarForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/calendars',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.calendarForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/calendars',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },

    changeOptionYear(yearSel, $event) {
      this.showHideLoading(true);
      this.calendarForm.yearSel = yearSel;
      try {
        let obj = event.path[0];
        setTimeout(() => {
          Object.values(
            document.getElementsByClassName('custom-el-menu-item-cal')
          ).forEach((element) => {
            if (obj != element) {
              element.classList.remove('is-active');
            }
          });
          this.showHideLoading();
        }, 100);
      } catch (error) {
        this.showHideLoading();
      }
    },
  },

  mounted() {
    this.selectedItemOnMenu('calendars');
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    this.deselectedItemOnMenu('calendars');
  },
};
</script>
<style></style>
